const ROLES = [
    { key: 'BILLING', label: 'Billing', icon: '🧾', color: '#2563eb', demoUser: 'cashier' },
    { key: 'CHEF', label: 'Chef', icon: '👨‍🍳', color: '#ea580c', demoUser: 'mike_chef' },
    { key: 'WAITER', label: 'Waiter', icon: '🍽️', color: '#0d9488', demoUser: 'john_waiter' },
    { key: 'ADMIN', label: 'Admin', icon: '⚙️', color: '#7c3aed', demoUser: 'admin' }
];

export default ROLES;
